/*eslint-disable no-useless-constructor */

/*eslint-disable array-callback-return */

/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { ToastContainer, toast } from 'react-toastify';
import Header from '../../components/common/Header/Header';

import ProfileInformation from './Component/ProfileInformation';
import ChangePassword from './Component/ChangePassword';
import { useAccountSetup, usePasswordRecovery } from '../OnBoarding/hooks';
import EditProfileForm from './Component/EditProfileForm';
import 'react-web-tabs/dist/react-web-tabs.css';
import './myprofile.scss';
import './preference.scss';
import Affiliation from './Component/Affiliation';
import OnetimePassword from './Component/OneTimePassword';
import PasswordSuccess from './Component/PasswordSuccess';

//import ConfigurationTable from './configurationTable/configurationTable';

const MyProfile = (props) => {
  const [showEditForm, setShowEditForm] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = props;

  const { userData } = useSelector((state) => state?.user);
  console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>><<<+++', userData);

  const {
    currentStep,
    schema,
    passwordSchema,
    securityQuestionschema,
    passwordRules,
    showPassword,
    showConfirmPassword,
    formData,
    privacyPolicyContent,
    termsConditionContent,
    isButtonDisable,
    nextStep,
    prevStep,
    setShowPassword,
    setShowConfirmPassword,
    handleInput,
    updateUser,
    getStepTitle,
    selectedQuestionValues,
    handleQuestionValChange,
    countryCodeList,
    handleFormData,
    updateSecurityQuestions,
    showSkeletonLoader,
    registrationUrlValid,
    isRegistered,
    serverError,
    handleSecurityQuestionsError,
    fetchSecurityQuestions,
    insurerClientSettings,
  } = useAccountSetup({ defaultUserData: userData });

  const {
    email,
    OTPExpiry,
    OTPLength,
    OTPAttempts,
    userDetails,
    skeletonLoader,
    setUserDetails,
    setEmail,
  } = usePasswordRecovery();
  const [details, setDetails] = useState({});
  const updateDetails = (values) => {
    setDetails(values);
  };
  return (
    <div>
      <Container fluid className="claims-details">
        <Header linkTo={'/admin/admin-dashboard'} header={t('My Profile')} />

        <Row>
          <Col>
            <Tabs defaultTab="vertical-tab-one" vertical>
              <TabList>
                <Tab tabFor="vertical-tab-one" role="navigation">
                  Affiliation
                </Tab>
                <Tab tabFor="vertical-tab-two" role="navigation">
                  Profile Information
                </Tab>
                <Tab tabFor="vertical-tab-three" role="navigation">
                  Change Password
                </Tab>
              </TabList>

              <TabPanel tabId="vertical-tab-one" className="personal-info">
                <Affiliation />
              </TabPanel>

              <TabPanel tabId="vertical-tab-two" className="personal-info">
                {!showEditForm && (
                  <ProfileInformation
                    onClickEditButton={() => {
                      setShowEditForm(true);
                    }}
                  />
                )}
                {showEditForm && (
                  <EditProfileForm
                    currentStep={currentStep}
                    nextStep={nextStep}
                    onSubmitForm={updateUser}
                    schema={schema}
                    userData={userData}
                    formData={formData}
                    handleInput={handleInput}
                    countryCodeList={countryCodeList}
                    onClickCancel={() => {
                      setShowEditForm(false);
                    }}
                    //serverError={serverError}
                  />
                )}
              </TabPanel>
              <TabPanel tabId="vertical-tab-three" className="personal-info">
                {currentStep === 1 && (
                  <ChangePassword
                    currentStep={currentStep}
                    nextStep={nextStep}
                    schema={schema}
                    userData={userData}
                    formData={formData}
                    updateDetails={updateDetails}
                  />
                )}
                {currentStep === 2 && (
                  <OnetimePassword
                    currentStep={currentStep}
                    nextStep={nextStep}
                    prevStep={prevStep}
                    email={userData?.UserID}
                    OTPExpiry={
                      OTPExpiry === 0
                        ? insurerClientSettings?.OTPExpiresIn
                        : OTPExpiry
                    }
                    OTPLength={
                      OTPLength === 0
                        ? insurerClientSettings?.OTPLength
                        : OTPLength
                    }
                    OTPAttempts={OTPAttempts}
                    details={details}
                  />
                )}
              </TabPanel>
            </Tabs>
            <div className="toastify">
              <ToastContainer
                draggable
                pauseOnHover
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                autoClose={5000}
                position="top-center"
                newestOnTop={false}
                hideProgressBar={false}
                className="toastcontainer"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withTranslation()(MyProfile);
